import { cn } from "@/shared/lib/cn";
import { BrandMark } from "./BrandMark";

/**
 * 30px / 8px-radius avatar (DESIGN.md §4.1). `user` is a tonal bubble fill
 * with a serif initial; `assistant` is the ink brand mark.
 */
export interface AvatarProps {
  kind?: "user" | "assistant";
  /** Single-letter initial for the user variant. */
  label?: string;
  className?: string;
}

export function Avatar({ kind = "user", label, className }: AvatarProps) {
  const initial = label?.trim().slice(0, 1).toUpperCase();

  // Assistant, or a user with no resolvable initial (loading / errored `me`),
  // falls back to the brand mark — never an empty box.
  if (kind === "assistant" || !initial) {
    return <BrandMark size={30} className={className} />;
  }

  return (
    <span
      aria-hidden="true"
      className={cn(
        "grid size-[30px] place-items-center rounded-[8px] bg-bubble font-serif text-[13px] font-medium text-ink",
        className,
      )}
    >
      {initial}
    </span>
  );
}
